// --- FLASH CARDS DATA ---
// Flash card content for algorithms and patterns revision
// Content for cards with md files is loaded from /flashcards/{id}.md

import { FlashCard } from '../types';

export const FLASH_CARDS_DATA: FlashCard[] = [
    {
        id: 'algo-a-star-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['a-star', 'comparison', 'graphs'],
    },
    {
        id: 'algo-a-star-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['a-star', 'concepts', 'graphs'],
    },
    {
        id: 'algo-a-star-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['a-star', 'forms', 'graphs'],
    },
    {
        id: 'algo-a-star-frameworks',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['a-star', 'frameworks', 'graphs'],
    },
    {
        id: 'algo-a-star-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['a-star', 'tactics', 'graphs'],
    },
    {
        id: 'algo-activity-selection-comparison',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['activity-selection', 'comparison', 'greedy'],
    },
    {
        id: 'algo-activity-selection-concepts',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['activity-selection', 'concepts', 'greedy'],
    },
    {
        id: 'algo-activity-selection-forms',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['activity-selection', 'forms', 'greedy'],
    },
    {
        id: 'algo-activity-selection-frameworks',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['activity-selection', 'frameworks', 'greedy'],
    },
    {
        id: 'algo-activity-selection-tactics',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['activity-selection', 'tactics', 'greedy'],
    },
    {
        id: 'algo-backtracking-comparison',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['backtracking', 'comparison', 'backtracking'],
    },
    {
        id: 'algo-backtracking-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['backtracking', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-backtracking-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['backtracking', 'forms', 'backtracking'],
    },
    {
        id: 'algo-backtracking-frameworks',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['backtracking', 'frameworks', 'backtracking'],
    },
    {
        id: 'algo-backtracking-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['backtracking', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-bellman-ford-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bellman-ford', 'comparison', 'graphs'],
    },
    {
        id: 'algo-bellman-ford-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bellman-ford', 'concepts', 'graphs'],
    },
    {
        id: 'algo-bellman-ford-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bellman-ford', 'forms', 'graphs'],
    },
    {
        id: 'algo-bellman-ford-frameworks',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bellman-ford', 'frameworks', 'graphs'],
    },
    {
        id: 'algo-bellman-ford-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['bellman-ford', 'tactics', 'graphs'],
    },
    {
        id: 'algo-bfs-level-order-comparison',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bfs-level-order', 'comparison', 'trees-bsts'],
    },
    {
        id: 'algo-bfs-level-order-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bfs-level-order', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-bfs-level-order-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bfs-level-order', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-bfs-level-order-frameworks',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bfs-level-order', 'frameworks', 'trees-bsts'],
    },
    {
        id: 'algo-bfs-level-order-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['bfs-level-order', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-binary-lifting-comparison',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-lifting', 'comparison', 'advanced'],
    },
    {
        id: 'algo-binary-lifting-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-lifting', 'concepts', 'advanced'],
    },
    {
        id: 'algo-binary-lifting-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-lifting', 'forms', 'advanced'],
    },
    {
        id: 'algo-binary-lifting-frameworks',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-lifting', 'frameworks', 'advanced'],
    },
    {
        id: 'algo-binary-lifting-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-lifting', 'tactics', 'advanced'],
    },
    {
        id: 'algo-binary-search-comparison',
        type: 'algorithm',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'comparison', 'binary-search'],
    },
    {
        id: 'algo-binary-search-concepts',
        type: 'algorithm',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'concepts', 'binary-search'],
    },
    {
        id: 'algo-binary-search-forms',
        type: 'algorithm',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'forms', 'binary-search'],
    },
    {
        id: 'algo-binary-search-frameworks',
        type: 'algorithm',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'frameworks', 'binary-search'],
    },
    {
        id: 'algo-binary-search-tactics',
        type: 'algorithm',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-search', 'tactics', 'binary-search'],
    },
    {
        id: 'algo-bst-insert-comparison',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bst-insert', 'comparison', 'trees-bsts'],
    },
    {
        id: 'algo-bst-insert-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bst-insert', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-bst-insert-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bst-insert', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-bst-insert-frameworks',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bst-insert', 'frameworks', 'trees-bsts'],
    },
    {
        id: 'algo-bst-insert-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['bst-insert', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-catalan-numbers-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['catalan-numbers', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-catalan-numbers-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['catalan-numbers', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-catalan-numbers-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['catalan-numbers', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-catalan-numbers-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['catalan-numbers', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-catalan-numbers-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['catalan-numbers', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-chinese-remainder-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['chinese-remainder', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-chinese-remainder-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['chinese-remainder', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-chinese-remainder-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['chinese-remainder', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-chinese-remainder-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['chinese-remainder', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-chinese-remainder-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['chinese-remainder', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-climbing-stairs-comparison',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['climbing-stairs', 'comparison', 'dynamic-programming'],
    },
    {
        id: 'algo-climbing-stairs-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['climbing-stairs', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-climbing-stairs-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['climbing-stairs', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-climbing-stairs-frameworks',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['climbing-stairs', 'frameworks', 'dynamic-programming'],
    },
    {
        id: 'algo-climbing-stairs-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['climbing-stairs', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-coin-change-comparison',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['coin-change', 'comparison', 'dynamic-programming'],
    },
    {
        id: 'algo-coin-change-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['coin-change', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-coin-change-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['coin-change', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-coin-change-frameworks',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['coin-change', 'frameworks', 'dynamic-programming'],
    },
    {
        id: 'algo-coin-change-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['coin-change', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-combination-sum-comparison',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['combination-sum', 'comparison', 'backtracking'],
    },
    {
        id: 'algo-combination-sum-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['combination-sum', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-combination-sum-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['combination-sum', 'forms', 'backtracking'],
    },
    {
        id: 'algo-combination-sum-frameworks',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['combination-sum', 'frameworks', 'backtracking'],
    },
    {
        id: 'algo-combination-sum-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['combination-sum', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-combinations-comparison',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['combinations', 'comparison', 'backtracking'],
    },
    {
        id: 'algo-combinations-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['combinations', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-combinations-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['combinations', 'forms', 'backtracking'],
    },
    {
        id: 'algo-combinations-frameworks',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['combinations', 'frameworks', 'backtracking'],
    },
    {
        id: 'algo-combinations-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['combinations', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-count-bits-comparison',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['count-bits', 'comparison', 'bit-manipulation'],
    },
    {
        id: 'algo-count-bits-concepts',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['count-bits', 'concepts', 'bit-manipulation'],
    },
    {
        id: 'algo-count-bits-forms',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['count-bits', 'forms', 'bit-manipulation'],
    },
    {
        id: 'algo-count-bits-frameworks',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['count-bits', 'frameworks', 'bit-manipulation'],
    },
    {
        id: 'algo-count-bits-tactics',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['count-bits', 'tactics', 'bit-manipulation'],
    },
    {
        id: 'algo-cyclic-sort-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['cyclic-sort', 'comparison'],
    },
    {
        id: 'algo-cyclic-sort-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['cyclic-sort', 'concepts'],
    },
    {
        id: 'algo-cyclic-sort-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['cyclic-sort', 'forms'],
    },
    {
        id: 'algo-cyclic-sort-frameworks',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['cyclic-sort', 'frameworks'],
    },
    {
        id: 'algo-cyclic-sort-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['cyclic-sort', 'tactics'],
    },
    {
        id: 'algo-detect-cycle-comparison',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['detect-cycle', 'comparison', 'linked-list'],
    },
    {
        id: 'algo-detect-cycle-concepts',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['detect-cycle', 'concepts', 'linked-list'],
    },
    {
        id: 'algo-detect-cycle-forms',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['detect-cycle', 'forms', 'linked-list'],
    },
    {
        id: 'algo-detect-cycle-frameworks',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['detect-cycle', 'frameworks', 'linked-list'],
    },
    {
        id: 'algo-detect-cycle-tactics',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['detect-cycle', 'tactics', 'linked-list'],
    },
    {
        id: 'algo-dfs-inorder-comparison',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dfs-inorder', 'comparison', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-inorder-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dfs-inorder', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-inorder-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dfs-inorder', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-inorder-frameworks',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dfs-inorder', 'frameworks', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-inorder-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['dfs-inorder', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-postorder-comparison',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dfs-postorder', 'comparison', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-postorder-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dfs-postorder', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-postorder-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dfs-postorder', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-postorder-frameworks',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dfs-postorder', 'frameworks', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-postorder-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['dfs-postorder', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-preorder-comparison',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dfs-preorder', 'comparison', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-preorder-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dfs-preorder', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-preorder-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dfs-preorder', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-preorder-frameworks',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dfs-preorder', 'frameworks', 'trees-bsts'],
    },
    {
        id: 'algo-dfs-preorder-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['dfs-preorder', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-dijkstras-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dijkstras', 'comparison', 'graphs'],
    },
    {
        id: 'algo-dijkstras-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dijkstras', 'concepts', 'graphs'],
    },
    {
        id: 'algo-dijkstras-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dijkstras', 'forms', 'graphs'],
    },
    {
        id: 'algo-dijkstras-frameworks',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dijkstras', 'frameworks', 'graphs'],
    },
    {
        id: 'algo-dijkstras-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['dijkstras', 'tactics', 'graphs'],
    },
    {
        id: 'algo-dutch-national-flag-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dutch-national-flag', 'comparison'],
    },
    {
        id: 'algo-dutch-national-flag-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dutch-national-flag', 'concepts'],
    },
    {
        id: 'algo-dutch-national-flag-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dutch-national-flag', 'forms'],
    },
    {
        id: 'algo-dutch-national-flag-frameworks',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dutch-national-flag', 'frameworks'],
    },
    {
        id: 'algo-dutch-national-flag-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['dutch-national-flag', 'tactics'],
    },
    {
        id: 'algo-edit-distance-comparison',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['edit-distance', 'comparison', 'dynamic-programming'],
    },
    {
        id: 'algo-edit-distance-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['edit-distance', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-edit-distance-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['edit-distance', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-edit-distance-frameworks',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['edit-distance', 'frameworks', 'dynamic-programming'],
    },
    {
        id: 'algo-edit-distance-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['edit-distance', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-extended-euclidean-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['extended-euclidean', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-extended-euclidean-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['extended-euclidean', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-extended-euclidean-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['extended-euclidean', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-extended-euclidean-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['extended-euclidean', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-fast-slow-pointers-comparison',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['fast-slow-pointers', 'comparison', 'linked-list'],
    },
    {
        id: 'algo-fast-slow-pointers-concepts',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['fast-slow-pointers', 'concepts', 'linked-list'],
    },
    {
        id: 'algo-fast-slow-pointers-forms',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['fast-slow-pointers', 'forms', 'linked-list'],
    },
    {
        id: 'algo-fast-slow-pointers-frameworks',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['fast-slow-pointers', 'frameworks', 'linked-list'],
    },
    {
        id: 'algo-fast-slow-pointers-tactics',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['fast-slow-pointers', 'tactics', 'linked-list'],
    },
    {
        id: 'algo-fenwick-tree-comparison',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['fenwick-tree', 'comparison', 'advanced'],
    },
    {
        id: 'algo-fenwick-tree-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['fenwick-tree', 'concepts', 'advanced'],
    },
    {
        id: 'algo-fenwick-tree-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['fenwick-tree', 'forms', 'advanced'],
    },
    {
        id: 'algo-fenwick-tree-frameworks',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['fenwick-tree', 'frameworks', 'advanced'],
    },
    {
        id: 'algo-fenwick-tree-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['fenwick-tree', 'tactics', 'advanced'],
    },
    {
        id: 'algo-fft-ntt-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['fft-ntt', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-fft-ntt-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['fft-ntt', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-fft-ntt-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['fft-ntt', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-fft-ntt-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['fft-ntt', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-fft-ntt-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['fft-ntt', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-floyd-warshall-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['floyd-warshall', 'comparison', 'graphs'],
    },
    {
        id: 'algo-floyd-warshall-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['floyd-warshall', 'concepts', 'graphs'],
    },
    {
        id: 'algo-floyd-warshall-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['floyd-warshall', 'forms', 'graphs'],
    },
    {
        id: 'algo-floyd-warshall-frameworks',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['floyd-warshall', 'frameworks', 'graphs'],
    },
    {
        id: 'algo-floyd-warshall-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['floyd-warshall', 'tactics', 'graphs'],
    },
    {
        id: 'algo-game-theory-nim-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['game-theory-nim', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-game-theory-nim-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['game-theory-nim', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-game-theory-nim-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['game-theory-nim', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-game-theory-nim-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['game-theory-nim', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-game-theory-nim-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['game-theory-nim', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-gas-station-comparison',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['gas-station', 'comparison', 'greedy'],
    },
    {
        id: 'algo-gas-station-concepts',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['gas-station', 'concepts', 'greedy'],
    },
    {
        id: 'algo-gas-station-forms',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['gas-station', 'forms', 'greedy'],
    },
    {
        id: 'algo-gas-station-frameworks',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['gas-station', 'frameworks', 'greedy'],
    },
    {
        id: 'algo-gas-station-tactics',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['gas-station', 'tactics', 'greedy'],
    },
    {
        id: 'algo-gcd-euclidean-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['gcd-euclidean', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-gcd-euclidean-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['gcd-euclidean', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-gcd-euclidean-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['gcd-euclidean', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-gcd-euclidean-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['gcd-euclidean', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-gcd-euclidean-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['gcd-euclidean', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-graph-bfs-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graph-bfs', 'comparison', 'graphs'],
    },
    {
        id: 'algo-graph-bfs-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graph-bfs', 'concepts', 'graphs'],
    },
    {
        id: 'algo-graph-bfs-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graph-bfs', 'forms', 'graphs'],
    },
    {
        id: 'algo-graph-bfs-frameworks',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graph-bfs', 'frameworks', 'graphs'],
    },
    {
        id: 'algo-graph-bfs-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['graph-bfs', 'tactics', 'graphs'],
    },
    {
        id: 'algo-graph-dfs-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graph-dfs', 'comparison', 'graphs'],
    },
    {
        id: 'algo-graph-dfs-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graph-dfs', 'concepts', 'graphs'],
    },
    {
        id: 'algo-graph-dfs-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graph-dfs', 'forms', 'graphs'],
    },
    {
        id: 'algo-graph-dfs-frameworks',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graph-dfs', 'frameworks', 'graphs'],
    },
    {
        id: 'algo-graph-dfs-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['graph-dfs', 'tactics', 'graphs'],
    },
    {
        id: 'algo-house-robber-comparison',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['house-robber', 'comparison', 'dynamic-programming'],
    },
    {
        id: 'algo-house-robber-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['house-robber', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-house-robber-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['house-robber', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-house-robber-frameworks',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['house-robber', 'frameworks', 'dynamic-programming'],
    },
    {
        id: 'algo-house-robber-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['house-robber', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-huffman-encoding-comparison',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['huffman-encoding', 'comparison', 'greedy'],
    },
    {
        id: 'algo-huffman-encoding-concepts',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['huffman-encoding', 'concepts', 'greedy'],
    },
    {
        id: 'algo-huffman-encoding-forms',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['huffman-encoding', 'forms', 'greedy'],
    },
    {
        id: 'algo-huffman-encoding-frameworks',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['huffman-encoding', 'frameworks', 'greedy'],
    },
    {
        id: 'algo-huffman-encoding-tactics',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['huffman-encoding', 'tactics', 'greedy'],
    },
    {
        id: 'algo-inclusion-exclusion-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['inclusion-exclusion', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-inclusion-exclusion-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['inclusion-exclusion', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-inclusion-exclusion-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['inclusion-exclusion', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-inclusion-exclusion-frameworks',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['inclusion-exclusion', 'frameworks', 'math-number-theory'],
    },
    {
        id: 'algo-inclusion-exclusion-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['inclusion-exclusion', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-interval-scheduling-comparison',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['interval-scheduling', 'comparison', 'greedy'],
    },
    {
        id: 'algo-interval-scheduling-concepts',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['interval-scheduling', 'concepts', 'greedy'],
    },
    {
        id: 'algo-interval-scheduling-forms',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['interval-scheduling', 'forms', 'greedy'],
    },
    {
        id: 'algo-interval-scheduling-frameworks',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['interval-scheduling', 'frameworks', 'greedy'],
    },
    {
        id: 'algo-interval-scheduling-tactics',
        type: 'algorithm',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['interval-scheduling', 'tactics', 'greedy'],
    },
    {
        id: 'algo-kadanes-algorithm-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kadanes-algorithm', 'comparison'],
    },
    {
        id: 'algo-kadanes-algorithm-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kadanes-algorithm', 'concepts'],
    },
    {
        id: 'algo-kadanes-algorithm-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kadanes-algorithm', 'forms'],
    },
    {
        id: 'algo-kadanes-algorithm-frameworks',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kadanes-algorithm', 'frameworks'],
    },
    {
        id: 'algo-kadanes-algorithm-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['kadanes-algorithm', 'tactics'],
    },
    {
        id: 'algo-karatsuba-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['karatsuba', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-karatsuba-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['karatsuba', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-karatsuba-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['karatsuba', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-karatsuba-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['karatsuba', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-karatsuba-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['karatsuba', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-kmp-comparison',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kmp', 'comparison', 'advanced'],
    },
    {
        id: 'algo-kmp-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kmp', 'concepts', 'advanced'],
    },
    {
        id: 'algo-kmp-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kmp', 'forms', 'advanced'],
    },
    {
        id: 'algo-kmp-framework',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kmp', 'framework', 'advanced'],
    },
    {
        id: 'algo-kmp-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['kmp', 'tactics', 'advanced'],
    },
    {
        id: 'algo-knapsack-01-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['knapsack-01', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-knapsack-01-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['knapsack-01', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-knapsack-01-framework',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['knapsack-01', 'framework', 'dynamic-programming'],
    },
    {
        id: 'algo-knapsack-01-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['knapsack-01', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-kruskals-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kruskals', 'comparison', 'graphs'],
    },
    {
        id: 'algo-kruskals-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kruskals', 'concepts', 'graphs'],
    },
    {
        id: 'algo-kruskals-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kruskals', 'forms', 'graphs'],
    },
    {
        id: 'algo-kruskals-framework',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kruskals', 'framework', 'graphs'],
    },
    {
        id: 'algo-kruskals-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['kruskals', 'tactics', 'graphs'],
    },
    {
        id: 'algo-kth-largest-concepts',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['kth-largest', 'concepts', 'heap-priority-queue'],
    },
    {
        id: 'algo-kth-largest-forms',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kth-largest', 'forms', 'heap-priority-queue'],
    },
    {
        id: 'algo-kth-largest-framework',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['kth-largest', 'framework', 'heap-priority-queue'],
    },
    {
        id: 'algo-kth-largest-tactics',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['kth-largest', 'tactics', 'heap-priority-queue'],
    },
    {
        id: 'algo-lca-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['lca', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-lca-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lca', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-lca-framework',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lca', 'framework', 'trees-bsts'],
    },
    {
        id: 'algo-lca-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['lca', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-lcs-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['lcs', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-lcs-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lcs', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-lcs-framework',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lcs', 'framework', 'dynamic-programming'],
    },
    {
        id: 'algo-linear-sieve-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['linear-sieve', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-linear-sieve-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['linear-sieve', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-linear-sieve-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['linear-sieve', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-linear-sieve-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['linear-sieve', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-lis-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['lis', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-lis-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lis', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-lis-framework',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lis', 'framework', 'dynamic-programming'],
    },
    {
        id: 'algo-lis-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['lis', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-lru-cache-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['lru-cache', 'concepts', 'advanced'],
    },
    {
        id: 'algo-lru-cache-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lru-cache', 'forms', 'advanced'],
    },
    {
        id: 'algo-lru-cache-framework',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['lru-cache', 'framework', 'advanced'],
    },
    {
        id: 'algo-lru-cache-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['lru-cache', 'tactics', 'advanced'],
    },
    {
        id: 'algo-manachers-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['manachers', 'concepts', 'advanced'],
    },
    {
        id: 'algo-manachers-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['manachers', 'forms', 'advanced'],
    },
    {
        id: 'algo-manachers-framework',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['manachers', 'framework', 'advanced'],
    },
    {
        id: 'algo-manachers-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['manachers', 'tactics', 'advanced'],
    },
    {
        id: 'algo-matrix-exponentiation-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['matrix-exponentiation', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-matrix-exponentiation-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['matrix-exponentiation', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-matrix-exponentiation-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['matrix-exponentiation', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-matrix-exponentiation-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['matrix-exponentiation', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-matrix-path-dp-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['matrix-path-dp', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-matrix-path-dp-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['matrix-path-dp', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-matrix-path-dp-framework',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['matrix-path-dp', 'framework', 'dynamic-programming'],
    },
    {
        id: 'algo-matrix-path-dp-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['matrix-path-dp', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-merge-intervals-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['merge-intervals', 'comparison'],
    },
    {
        id: 'algo-merge-intervals-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['merge-intervals', 'concepts'],
    },
    {
        id: 'algo-merge-intervals-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['merge-intervals', 'forms'],
    },
    {
        id: 'algo-merge-intervals-framework',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['merge-intervals', 'framework'],
    },
    {
        id: 'algo-merge-intervals-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['merge-intervals', 'tactics'],
    },
    {
        id: 'algo-merge-k-lists-comparison',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['merge-k-lists', 'comparison', 'heap-priority-queue'],
    },
    {
        id: 'algo-merge-k-lists-concepts',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['merge-k-lists', 'concepts', 'heap-priority-queue'],
    },
    {
        id: 'algo-merge-k-lists-forms',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['merge-k-lists', 'forms', 'heap-priority-queue'],
    },
    {
        id: 'algo-merge-k-lists-framework',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['merge-k-lists', 'framework', 'heap-priority-queue'],
    },
    {
        id: 'algo-merge-k-lists-tactics',
        type: 'algorithm',
        category: 'heap-priority-queue',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['merge-k-lists', 'tactics', 'heap-priority-queue'],
    },
    {
        id: 'algo-merge-sorted-lists-comparison',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['merge-sorted-lists', 'comparison', 'linked-list'],
    },
    {
        id: 'algo-merge-sorted-lists-concepts',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['merge-sorted-lists', 'concepts', 'linked-list'],
    },
    {
        id: 'algo-merge-sorted-lists-forms',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['merge-sorted-lists', 'forms', 'linked-list'],
    },
    {
        id: 'algo-merge-sorted-lists-framework',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['merge-sorted-lists', 'framework', 'linked-list'],
    },
    {
        id: 'algo-merge-sorted-lists-tactics',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['merge-sorted-lists', 'tactics', 'linked-list'],
    },
    {
        id: 'algo-middle-node-concepts',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['middle-node', 'concepts', 'linked-list'],
    },
    {
        id: 'algo-middle-node-forms',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['middle-node', 'forms', 'linked-list'],
    },
    {
        id: 'algo-middle-node-framework',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['middle-node', 'framework', 'linked-list'],
    },
    {
        id: 'algo-middle-node-tactics',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['middle-node', 'tactics', 'linked-list'],
    },
    {
        id: 'algo-miller-rabin-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['miller-rabin', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-miller-rabin-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['miller-rabin', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-miller-rabin-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['miller-rabin', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-miller-rabin-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['miller-rabin', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-modular-exponentiation-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['modular-exponentiation', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-modular-exponentiation-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['modular-exponentiation', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-modular-exponentiation-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['modular-exponentiation', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-modular-exponentiation-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['modular-exponentiation', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-modular-exponentiation-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['modular-exponentiation', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-modular-inverse-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['modular-inverse', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-modular-inverse-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['modular-inverse', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-modular-inverse-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['modular-inverse', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-modular-inverse-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['modular-inverse', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-modular-inverse-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['modular-inverse', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-monotonic-stack-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['monotonic-stack', 'comparison'],
    },
    {
        id: 'algo-monotonic-stack-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['monotonic-stack', 'concepts'],
    },
    {
        id: 'algo-monotonic-stack-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['monotonic-stack', 'forms'],
    },
    {
        id: 'algo-monotonic-stack-framework',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['monotonic-stack', 'framework'],
    },
    {
        id: 'algo-monotonic-stack-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['monotonic-stack', 'tactics'],
    },
    {
        id: 'algo-n-queens-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['n-queens', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-n-queens-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['n-queens', 'forms', 'backtracking'],
    },
    {
        id: 'algo-n-queens-framework',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['n-queens', 'framework', 'backtracking'],
    },
    {
        id: 'algo-n-queens-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['n-queens', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-ncr-binomial-comparison',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['ncr-binomial', 'comparison', 'math-number-theory'],
    },
    {
        id: 'algo-ncr-binomial-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['ncr-binomial', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-ncr-binomial-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['ncr-binomial', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-ncr-binomial-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['ncr-binomial', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-ncr-binomial-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['ncr-binomial', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-partition-equal-subset-comparison',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['partition-equal-subset', 'comparison', 'dynamic-programming'],
    },
    {
        id: 'algo-partition-equal-subset-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['partition-equal-subset', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-partition-equal-subset-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['partition-equal-subset', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-partition-equal-subset-framework',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['partition-equal-subset', 'framework', 'dynamic-programming'],
    },
    {
        id: 'algo-partition-equal-subset-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['partition-equal-subset', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-permutations-comparison',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['permutations', 'comparison', 'backtracking'],
    },
    {
        id: 'algo-permutations-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['permutations', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-permutations-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['permutations', 'forms', 'backtracking'],
    },
    {
        id: 'algo-permutations-framework',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['permutations', 'framework', 'backtracking'],
    },
    {
        id: 'algo-permutations-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['permutations', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-prefix-sum-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['prefix-sum', 'comparison'],
    },
    {
        id: 'algo-prefix-sum-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['prefix-sum', 'concepts'],
    },
    {
        id: 'algo-prefix-sum-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['prefix-sum', 'forms'],
    },
    {
        id: 'algo-prefix-sum-framework',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['prefix-sum', 'framework'],
    },
    {
        id: 'algo-prefix-sum-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['prefix-sum', 'tactics'],
    },
    {
        id: 'algo-prims-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['prims', 'comparison', 'graphs'],
    },
    {
        id: 'algo-prims-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['prims', 'concepts', 'graphs'],
    },
    {
        id: 'algo-prims-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['prims', 'forms', 'graphs'],
    },
    {
        id: 'algo-prims-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['prims', 'tactics', 'graphs'],
    },
    {
        id: 'algo-rabin-karp-comparison',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['rabin-karp', 'comparison', 'advanced'],
    },
    {
        id: 'algo-rabin-karp-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['rabin-karp', 'concepts', 'advanced'],
    },
    {
        id: 'algo-rabin-karp-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['rabin-karp', 'forms', 'advanced'],
    },
    {
        id: 'algo-rabin-karp-framework',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['rabin-karp', 'framework', 'advanced'],
    },
    {
        id: 'algo-rabin-karp-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['rabin-karp', 'tactics', 'advanced'],
    },
    {
        id: 'algo-recover-bst-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['recover-bst', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-recover-bst-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['recover-bst', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-recover-bst-framework',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['recover-bst', 'framework', 'trees-bsts'],
    },
    {
        id: 'algo-recover-bst-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['recover-bst', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-reverse-linked-list-comparison',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['reverse-linked-list', 'comparison', 'linked-list'],
    },
    {
        id: 'algo-reverse-linked-list-concepts',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['reverse-linked-list', 'concepts', 'linked-list'],
    },
    {
        id: 'algo-reverse-linked-list-forms',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['reverse-linked-list', 'forms', 'linked-list'],
    },
    {
        id: 'algo-reverse-linked-list-framework',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['reverse-linked-list', 'framework', 'linked-list'],
    },
    {
        id: 'algo-reverse-linked-list-tactics',
        type: 'algorithm',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['reverse-linked-list', 'tactics', 'linked-list'],
    },
    {
        id: 'algo-rotate-array-concepts',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['rotate-array', 'concepts'],
    },
    {
        id: 'algo-rotate-array-forms',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['rotate-array', 'forms'],
    },
    {
        id: 'algo-rotate-array-framework',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['rotate-array', 'framework'],
    },
    {
        id: 'algo-rotate-array-tactics',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['rotate-array', 'tactics'],
    },
    {
        id: 'algo-segment-tree-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['segment-tree', 'concepts', 'advanced'],
    },
    {
        id: 'algo-segment-tree-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['segment-tree', 'forms', 'advanced'],
    },
    {
        id: 'algo-segment-tree-framework',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['segment-tree', 'framework', 'advanced'],
    },
    {
        id: 'algo-segment-tree-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['segment-tree', 'tactics', 'advanced'],
    },
    {
        id: 'algo-serialize-tree-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['serialize-tree', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-serialize-tree-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['serialize-tree', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-serialize-tree-framework',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['serialize-tree', 'framework', 'trees-bsts'],
    },
    {
        id: 'algo-serialize-tree-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['serialize-tree', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-sieve-eratosthenes-concepts',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sieve-eratosthenes', 'concepts', 'math-number-theory'],
    },
    {
        id: 'algo-sieve-eratosthenes-forms',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sieve-eratosthenes', 'forms', 'math-number-theory'],
    },
    {
        id: 'algo-sieve-eratosthenes-framework',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sieve-eratosthenes', 'framework', 'math-number-theory'],
    },
    {
        id: 'algo-sieve-eratosthenes-tactics',
        type: 'algorithm',
        category: 'math-number-theory',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sieve-eratosthenes', 'tactics', 'math-number-theory'],
    },
    {
        id: 'algo-sliding-window-concepts',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'concepts', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-forms',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'forms', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-framework',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'framework', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-maximum-concepts',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window-maximum', 'concepts', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-maximum-forms',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window-maximum', 'forms', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-maximum-framework',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window-maximum', 'framework', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-maximum-tactics',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sliding-window-maximum', 'tactics', 'sliding-window'],
    },
    {
        id: 'algo-sliding-window-tactics',
        type: 'algorithm',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sliding-window', 'tactics'],
    },
    {
        id: 'algo-sparse-table-comparison',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sparse-table', 'comparison', 'advanced'],
    },
    {
        id: 'algo-sparse-table-concepts',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sparse-table', 'concepts', 'advanced'],
    },
    {
        id: 'algo-sparse-table-forms',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sparse-table', 'forms', 'advanced'],
    },
    {
        id: 'algo-sparse-table-framework',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sparse-table', 'framework', 'advanced'],
    },
    {
        id: 'algo-sparse-table-tactics',
        type: 'algorithm',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sparse-table', 'tactics', 'advanced'],
    },
    {
        id: 'algo-subset-generation-bits-concepts',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['subset-generation-bits', 'concepts', 'bit-manipulation'],
    },
    {
        id: 'algo-subset-generation-bits-forms',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['subset-generation-bits', 'forms', 'bit-manipulation'],
    },
    {
        id: 'algo-subset-generation-bits-framework',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['subset-generation-bits', 'framework', 'bit-manipulation'],
    },
    {
        id: 'algo-subset-generation-bits-tactics',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['subset-generation-bits', 'tactics', 'bit-manipulation'],
    },
    {
        id: 'algo-subsets-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['subsets', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-subsets-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['subsets', 'forms', 'backtracking'],
    },
    {
        id: 'algo-subsets-framework',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['subsets', 'framework', 'backtracking'],
    },
    {
        id: 'algo-subsets-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['subsets', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-sudoku-solver-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sudoku-solver', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-sudoku-solver-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sudoku-solver', 'forms', 'backtracking'],
    },
    {
        id: 'algo-sudoku-solver-framework',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sudoku-solver', 'framework', 'backtracking'],
    },
    {
        id: 'algo-sudoku-solver-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sudoku-solver', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-tarjans-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['tarjans', 'comparison', 'graphs'],
    },
    {
        id: 'algo-tarjans-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['tarjans', 'concepts', 'graphs'],
    },
    {
        id: 'algo-tarjans-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['tarjans', 'forms', 'graphs'],
    },
    {
        id: 'algo-tarjans-framework',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['tarjans', 'framework', 'graphs'],
    },
    {
        id: 'algo-tarjans-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tarjans', 'tactics', 'graphs'],
    },
    {
        id: 'algo-topological-sort-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['topological-sort', 'concepts', 'graphs'],
    },
    {
        id: 'algo-topological-sort-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['topological-sort', 'forms', 'graphs'],
    },
    {
        id: 'algo-topological-sort-framework',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['topological-sort', 'framework', 'graphs'],
    },
    {
        id: 'algo-topological-sort-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['topological-sort', 'tactics', 'graphs'],
    },
    {
        id: 'algo-trie-concepts',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['trie', 'concepts', 'trees-bsts'],
    },
    {
        id: 'algo-trie-forms',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['trie', 'forms', 'trees-bsts'],
    },
    {
        id: 'algo-trie-framework',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['trie', 'framework', 'trees-bsts'],
    },
    {
        id: 'algo-trie-tactics',
        type: 'algorithm',
        category: 'trees-bsts',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['trie', 'tactics', 'trees-bsts'],
    },
    {
        id: 'algo-two-pointers-concepts',
        type: 'algorithm',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'concepts', 'two-pointers'],
    },
    {
        id: 'algo-two-pointers-forms',
        type: 'algorithm',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'forms', 'two-pointers'],
    },
    {
        id: 'algo-two-pointers-framework',
        type: 'algorithm',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'framework', 'two-pointers'],
    },
    {
        id: 'algo-two-pointers-tactics',
        type: 'algorithm',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'tactics', 'two-pointers'],
    },
    {
        id: 'algo-union-by-rank-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['union-by-rank', 'comparison', 'graphs'],
    },
    {
        id: 'algo-union-by-rank-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['union-by-rank', 'concepts', 'graphs'],
    },
    {
        id: 'algo-union-by-rank-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['union-by-rank', 'forms', 'graphs'],
    },
    {
        id: 'algo-union-by-rank-framework',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['union-by-rank', 'framework', 'graphs'],
    },
    {
        id: 'algo-union-by-rank-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['union-by-rank', 'tactics', 'graphs'],
    },
    {
        id: 'algo-union-find-comparison',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['union-find', 'comparison', 'graphs'],
    },
    {
        id: 'algo-union-find-concepts',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['union-find', 'concepts', 'graphs'],
    },
    {
        id: 'algo-union-find-forms',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['union-find', 'forms', 'graphs'],
    },
    {
        id: 'algo-union-find-framework',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['union-find', 'framework', 'graphs'],
    },
    {
        id: 'algo-union-find-tactics',
        type: 'algorithm',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['union-find', 'tactics', 'graphs'],
    },
    {
        id: 'algo-word-break-comparison',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['word-break', 'comparison', 'dynamic-programming'],
    },
    {
        id: 'algo-word-break-concepts',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['word-break', 'concepts', 'dynamic-programming'],
    },
    {
        id: 'algo-word-break-forms',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['word-break', 'forms', 'dynamic-programming'],
    },
    {
        id: 'algo-word-break-framework',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['word-break', 'framework', 'dynamic-programming'],
    },
    {
        id: 'algo-word-break-tactics',
        type: 'algorithm',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['word-break', 'tactics', 'dynamic-programming'],
    },
    {
        id: 'algo-word-search-grid-comparison',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['word-search-grid', 'comparison', 'backtracking'],
    },
    {
        id: 'algo-word-search-grid-concepts',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['word-search-grid', 'concepts', 'backtracking'],
    },
    {
        id: 'algo-word-search-grid-forms',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['word-search-grid', 'forms', 'backtracking'],
    },
    {
        id: 'algo-word-search-grid-framework',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['word-search-grid', 'framework', 'backtracking'],
    },
    {
        id: 'algo-word-search-grid-tactics',
        type: 'algorithm',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['word-search-grid', 'tactics', 'backtracking'],
    },
    {
        id: 'algo-xor-trick-comparison',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['xor-trick', 'comparison', 'bit-manipulation'],
    },
    {
        id: 'algo-xor-trick-concepts',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['xor-trick', 'concepts', 'bit-manipulation'],
    },
    {
        id: 'algo-xor-trick-forms',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['xor-trick', 'forms', 'bit-manipulation'],
    },
    {
        id: 'algo-xor-trick-framework',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['xor-trick', 'framework', 'bit-manipulation'],
    },
    {
        id: 'algo-xor-trick-tactics',
        type: 'algorithm',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['xor-trick', 'tactics', 'bit-manipulation'],
    },
    {
        id: 'algo-sorting-comparison',
        type: 'algorithm',
        category: 'arrays-strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sorting', 'comparison', 'algorithms'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'fast-slow', 'cycle-detection', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'fast-slow', 'cycle-detection', 'forms'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'fast-slow', 'cycle-detection', 'framework'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'fast-slow', 'cycle-detection', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'fast-slow', 'cycle-detection', 'comparison'],
    },
    {
        id: 'pattern-two-pointers-converging-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'converging', 'sorted-array', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-converging-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'converging', 'sorted-array', 'forms'],
    },
    {
        id: 'pattern-two-pointers-converging-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'converging', 'sorted-array', 'framework'],
    },
    {
        id: 'pattern-two-pointers-converging-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'converging', 'sorted-array', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-converging-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'converging', 'sorted-array', 'comparison'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-backspaces-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'strings', 'backspace', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-backspaces-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'strings', 'backspace', 'framework'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-backspaces-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'strings', 'backspace', 'forms'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-backspaces-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'strings', 'backspace', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-backspaces-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'strings', 'backspace', 'comparison'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'fixed-separation', 'nth-from-end', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'fixed-separation', 'nth-from-end', 'framework'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'fixed-separation', 'nth-from-end', 'forms'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'fixed-separation', 'nth-from-end', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'fixed-separation', 'nth-from-end', 'comparison'],
    },
    {
        id: 'pattern-two-pointers-in-place-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'in-place', 'array-modification', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-in-place-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'in-place', 'array-modification', 'framework'],
    },
    {
        id: 'pattern-two-pointers-in-place-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'in-place', 'array-modification', 'forms'],
    },
    {
        id: 'pattern-two-pointers-in-place-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'in-place', 'array-modification', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-in-place-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'in-place', 'array-modification', 'comparison'],
    },
    {
        id: 'pattern-two-pointers-expanding-center-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'expanding-center', 'palindrome', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-expanding-center-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'expanding-center', 'palindrome', 'framework'],
    },
    {
        id: 'pattern-two-pointers-expanding-center-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'expanding-center', 'palindrome', 'forms'],
    },
    {
        id: 'pattern-two-pointers-expanding-center-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'expanding-center', 'palindrome', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-expanding-center-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'expanding-center', 'palindrome', 'comparison'],
    },
    {
        id: 'pattern-two-pointers-string-reversal-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'string-reversal', 'concepts'],
    },
    {
        id: 'pattern-two-pointers-string-reversal-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'string-reversal', 'framework'],
    },
    {
        id: 'pattern-two-pointers-string-reversal-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['two-pointers', 'string-reversal', 'forms'],
    },
    {
        id: 'pattern-two-pointers-string-reversal-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['two-pointers', 'string-reversal', 'tactics'],
    },
    {
        id: 'pattern-two-pointers-string-reversal-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['two-pointers', 'string-reversal', 'comparison'],
    },
    {
        id: 'pattern-sliding-window-variable-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'variable-size', 'concepts'],
    },
    {
        id: 'pattern-sliding-window-variable-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'variable-size', 'framework'],
    },
    {
        id: 'pattern-sliding-window-variable-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'variable-size', 'forms'],
    },
    {
        id: 'pattern-sliding-window-variable-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sliding-window', 'variable-size', 'tactics'],
    },
    {
        id: 'pattern-sliding-window-variable-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'variable-size', 'comparison'],
    },
    {
        id: 'pattern-sliding-window-fixed-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'fixed-size', 'concepts'],
    },
    {
        id: 'pattern-sliding-window-fixed-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'fixed-size', 'framework'],
    },
    {
        id: 'pattern-sliding-window-fixed-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'fixed-size', 'forms'],
    },
    {
        id: 'pattern-sliding-window-fixed-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sliding-window', 'fixed-size', 'tactics'],
    },
    {
        id: 'pattern-sliding-window-fixed-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'fixed-size', 'comparison'],
    },
    {
        id: 'pattern-sliding-window-char-freq-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'character-frequency', 'concepts'],
    },
    {
        id: 'pattern-sliding-window-char-freq-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'character-frequency', 'framework'],
    },
    {
        id: 'pattern-sliding-window-char-freq-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'character-frequency', 'forms'],
    },
    {
        id: 'pattern-sliding-window-char-freq-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sliding-window', 'character-frequency', 'tactics'],
    },
    {
        id: 'pattern-sliding-window-char-freq-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'character-frequency', 'comparison'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'monotonic-queue', 'concepts'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'monotonic-queue', 'framework'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['sliding-window', 'monotonic-queue', 'forms'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['sliding-window', 'monotonic-queue', 'tactics'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['sliding-window', 'monotonic-queue', 'comparison'],
    },
    {
        id: 'pattern-binary-search-sorted-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'sorted-array', 'concepts'],
    },
    {
        id: 'pattern-binary-search-sorted-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'sorted-array', 'framework'],
    },
    {
        id: 'pattern-binary-search-sorted-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'sorted-array', 'forms'],
    },
    {
        id: 'pattern-binary-search-sorted-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-search', 'sorted-array', 'tactics'],
    },
    {
        id: 'pattern-binary-search-sorted-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'sorted-array', 'comparison'],
    },
    {
        id: 'pattern-binary-search-rotated-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'rotated-array', 'concepts'],
    },
    {
        id: 'pattern-binary-search-rotated-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'rotated-array', 'framework'],
    },
    {
        id: 'pattern-binary-search-rotated-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'rotated-array', 'forms'],
    },
    {
        id: 'pattern-binary-search-rotated-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-search', 'rotated-array', 'tactics'],
    },
    {
        id: 'pattern-binary-search-rotated-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'rotated-array', 'comparison'],
    },
    {
        id: 'pattern-binary-search-answer-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'answer-space', 'optimization', 'concepts'],
    },
    {
        id: 'pattern-binary-search-answer-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'answer-space', 'optimization', 'framework'],
    },
    {
        id: 'pattern-binary-search-answer-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'answer-space', 'optimization', 'forms'],
    },
    {
        id: 'pattern-binary-search-answer-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-search', 'answer-space', 'optimization', 'tactics'],
    },
    {
        id: 'pattern-binary-search-answer-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'answer-space', 'optimization', 'comparison'],
    },
    {
        id: 'pattern-binary-search-two-arrays-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'two-arrays', 'median', 'concepts'],
    },
    {
        id: 'pattern-binary-search-two-arrays-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'two-arrays', 'median', 'framework'],
    },
    {
        id: 'pattern-binary-search-two-arrays-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'two-arrays', 'median', 'forms'],
    },
    {
        id: 'pattern-binary-search-two-arrays-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-search', 'two-arrays', 'median', 'tactics'],
    },
    {
        id: 'pattern-binary-search-two-arrays-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'two-arrays', 'median', 'comparison'],
    },
    {
        id: 'pattern-binary-search-first-last-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'first-last', 'boundaries', 'concepts'],
    },
    {
        id: 'pattern-binary-search-first-last-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'first-last', 'boundaries', 'framework'],
    },
    {
        id: 'pattern-binary-search-first-last-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['binary-search', 'first-last', 'boundaries', 'forms'],
    },
    {
        id: 'pattern-binary-search-first-last-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['binary-search', 'first-last', 'boundaries', 'tactics'],
    },
    {
        id: 'pattern-binary-search-first-last-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['binary-search', 'first-last', 'boundaries', 'comparison'],
    },
    {
        id: 'pattern-tree-dfs-inorder-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['trees', 'dfs', 'inorder', 'concepts'],
    },
    {
        id: 'pattern-tree-dfs-inorder-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['trees', 'dfs', 'inorder', 'framework'],
    },
    {
        id: 'pattern-tree-bfs-level-order-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['trees', 'bfs', 'level-order', 'concepts'],
    },
    {
        id: 'pattern-tree-bfs-level-order-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['trees', 'bfs', 'level-order', 'framework'],
    },
    {
        id: 'pattern-tree-bfs-level-order-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['trees', 'bfs', 'level-order', 'forms'],
    },
    {
        id: 'pattern-tree-bfs-level-order-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['trees', 'bfs', 'level-order', 'tactics'],
    },
    {
        id: 'pattern-tree-bfs-level-order-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['trees', 'bfs', 'level-order', 'comparison'],
    },
    {
        id: 'pattern-graph-union-find-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graphs', 'union-find', 'dsu', 'concepts'],
    },
    {
        id: 'pattern-graph-union-find-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graphs', 'union-find', 'dsu', 'framework'],
    },
    {
        id: 'pattern-graph-union-find-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graphs', 'union-find', 'dsu', 'forms'],
    },
    {
        id: 'pattern-graph-union-find-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['graphs', 'union-find', 'dsu', 'tactics'],
    },
    {
        id: 'pattern-graph-union-find-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graphs', 'union-find', 'dsu', 'comparison'],
    },
    {
        id: 'pattern-graph-bfs-dfs-traversal-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graphs', 'bfs', 'dfs', 'traversal', 'concepts'],
    },
    {
        id: 'pattern-graph-bfs-dfs-traversal-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graphs', 'bfs', 'dfs', 'traversal', 'framework'],
    },
    {
        id: 'pattern-graph-bfs-dfs-traversal-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graphs', 'bfs', 'dfs', 'traversal', 'forms'],
    },
    {
        id: 'pattern-graph-dijkstra-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graphs', 'dijkstra', 'shortest-path', 'concepts'],
    },
    {
        id: 'pattern-graph-dijkstra-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['graphs', 'dijkstra', 'shortest-path', 'framework'],
    },
    {
        id: 'pattern-graph-bfs-dfs-traversal-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['graphs', 'bfs', 'dfs', 'traversal', 'tactics'],
    },
    {
        id: 'pattern-graph-bfs-dfs-traversal-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['graphs', 'bfs', 'dfs', 'traversal', 'comparison'],
    },
    {
        id: 'pattern-dp-fibonacci-style-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dp', 'fibonacci', '1d-array', 'concepts'],
    },
    {
        id: 'pattern-dp-fibonacci-style-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dp', 'fibonacci', '1d-array', 'framework'],
    },
    {
        id: 'pattern-dp-knapsack-subset-sum-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['dp', 'knapsack', 'subset-sum', 'concepts'],
    },
    {
        id: 'pattern-dp-knapsack-subset-sum-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['dp', 'knapsack', 'subset-sum', 'framework'],
    },
    {
        id: 'pattern-backtracking-permutations-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['backtracking', 'permutations', 'concepts'],
    },
    {
        id: 'pattern-backtracking-permutations-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['backtracking', 'permutations', 'framework'],
    },
    {
        id: 'pattern-stack-valid-parentheses-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['stack', 'parentheses', 'matching', 'concepts'],
    },
    {
        id: 'pattern-stack-valid-parentheses-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['stack', 'parentheses', 'matching', 'framework'],
    },
    {
        id: 'pattern-heap-top-k-concepts',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['heap', 'top-k', 'priority-queue', 'concepts'],
    },
    {
        id: 'pattern-heap-top-k-framework',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['heap', 'top-k', 'priority-queue', 'framework'],
    },
    {
        id: 'pattern-linked-list-reversal-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['linked-list', 'reversal', 'in-place', 'concepts'],
    },
    {
        id: 'pattern-linked-list-reversal-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['linked-list', 'reversal', 'in-place', 'framework'],
    },
    {
        id: 'pattern-trie-prefix-tree-concepts',
        type: 'pattern',
        category: 'trie',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['trie', 'prefix-tree', 'string', 'concepts'],
    },
    {
        id: 'pattern-bitwise-xor-single-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['bitwise', 'xor', 'single-number', 'concepts'],
    },
    {
        id: 'pattern-bitwise-xor-single-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['bitwise', 'xor', 'single-number', 'framework'],
    },
    {
        id: 'pattern-string-anagram-check-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['string', 'anagram', 'frequency-count', 'concepts'],
    },
    {
        id: 'pattern-string-anagram-check-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['string', 'anagram', 'frequency-count', 'framework'],
    },
    {
        id: 'pattern-string-palindrome-check-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['string', 'palindrome', 'two-pointers', 'concepts'],
    },
    {
        id: 'pattern-string-palindrome-check-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['string', 'palindrome', 'two-pointers', 'framework'],
    },
    {
        id: 'pattern-array-cyclic-sort-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['array', 'cyclic-sort', 'in-place', 'concepts'],
    },
    {
        id: 'pattern-array-cyclic-sort-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['array', 'cyclic-sort', 'in-place', 'framework'],
    },
    {
        id: 'pattern-greedy-activity-selection-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['greedy', 'activity-selection', 'intervals', 'concepts'],
    },
    {
        id: 'pattern-greedy-activity-selection-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['greedy', 'activity-selection', 'intervals', 'framework'],
    },
    {
        id: 'pattern-advanced-topological-sort-concepts',
        type: 'pattern',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'topological', 'advanced'],
    },
    {
        id: 'pattern-advanced-topological-sort-framework',
        type: 'pattern',
        category: 'advanced',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'topological', 'advanced'],
    },
    {
        id: 'pattern-array-cyclic-sort-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'array', 'cyclic'],
    },
    {
        id: 'pattern-array-cyclic-sort-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'array', 'cyclic'],
    },
    {
        id: 'pattern-array-cyclic-sort-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'array', 'cyclic'],
    },
    {
        id: 'pattern-array-matrix-in-place-rotation-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-in-place-rotation-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-in-place-rotation-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-in-place-rotation-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-in-place-rotation-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-set-matrix-zeroes-in-place-marking-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-set-matrix-zeroes-in-place-marking-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-set-matrix-zeroes-in-place-marking-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-set-matrix-zeroes-in-place-marking-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-set-matrix-zeroes-in-place-marking-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'matrix', 'in-place'],
    },
    {
        id: 'pattern-array-matrix-set-zeroes-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'matrix'],
    },
    {
        id: 'pattern-array-matrix-set-zeroes-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'matrix'],
    },
    {
        id: 'pattern-array-matrix-set-zeroes-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'matrix'],
    },
    {
        id: 'pattern-array-matrix-set-zeroes-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'matrix'],
    },
    {
        id: 'pattern-array-matrix-set-zeroes-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'matrix'],
    },
    {
        id: 'pattern-array-matrix-spiral-traversal-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'matrix', 'spiral', 'traversal'],
    },
    {
        id: 'pattern-array-matrix-spiral-traversal-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'matrix', 'spiral', 'traversal'],
    },
    {
        id: 'pattern-array-matrix-spiral-traversal-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'matrix', 'spiral', 'traversal'],
    },
    {
        id: 'pattern-array-matrix-spiral-traversal-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'matrix', 'spiral', 'traversal'],
    },
    {
        id: 'pattern-array-matrix-spiral-traversal-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'matrix', 'spiral', 'traversal'],
    },
    {
        id: 'pattern-array-merge-sorted-array-in-place-from-end-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'merge', 'sort', 'sorted', 'array', 'in-place'],
    },
    {
        id: 'pattern-array-merge-sorted-array-in-place-from-end-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'merge', 'sort', 'sorted', 'array', 'in-place'],
    },
    {
        id: 'pattern-array-merge-sorted-array-in-place-from-end-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'merge', 'sort', 'sorted', 'array', 'in-place'],
    },
    {
        id: 'pattern-array-merge-sorted-array-in-place-from-end-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'merge', 'sort', 'sorted', 'array', 'in-place'],
    },
    {
        id: 'pattern-array-merge-sorted-array-in-place-from-end-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'merge', 'sort', 'sorted', 'array', 'in-place'],
    },
    {
        id: 'pattern-array-merge-sorted-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'merge', 'sort', 'sorted', 'array'],
    },
    {
        id: 'pattern-array-merge-sorted-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'merge', 'sort', 'sorted', 'array'],
    },
    {
        id: 'pattern-array-merge-sorted-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'merge', 'sort', 'sorted', 'array'],
    },
    {
        id: 'pattern-array-merge-sorted-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'merge', 'sort', 'sorted', 'array'],
    },
    {
        id: 'pattern-array-merge-sorted-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'merge', 'sort', 'sorted', 'array'],
    },
    {
        id: 'pattern-array-plus-one-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-array-plus-one-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-array-plus-one-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-array-plus-one-handling-carry-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-array-plus-one-handling-carry-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-array-plus-one-handling-carry-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-array-plus-one-handling-carry-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-array-plus-one-handling-carry-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-array-plus-one-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-array-product-except-self-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'product'],
    },
    {
        id: 'pattern-array-product-except-self-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'product'],
    },
    {
        id: 'pattern-array-product-except-self-prefix-suffix-products-comparison',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'product', 'prefix'],
    },
    {
        id: 'pattern-array-product-except-self-prefix-suffix-products-concepts',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'product', 'prefix'],
    },
    {
        id: 'pattern-array-product-except-self-prefix-suffix-products-forms',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'product', 'prefix'],
    },
    {
        id: 'pattern-array-product-except-self-prefix-suffix-products-framework',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'product', 'prefix'],
    },
    {
        id: 'pattern-array-product-except-self-prefix-suffix-products-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'product', 'prefix'],
    },
    {
        id: 'pattern-array-product-except-self-tactics',
        type: 'pattern',
        category: 'arrays',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'product'],
    },
    {
        id: 'pattern-backtracking-combination-sum-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sum', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-combination-sum-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sum', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-combination-sum-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sum', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-combination-sum-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sum', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-combination-sum-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sum', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-constraint-satisfaction-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-constraint-satisfaction-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-constraint-satisfaction-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-constraint-satisfaction-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-constraint-satisfaction-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-n-queens-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-palindrome-partitioning-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking', 'palindrome'],
    },
    {
        id: 'pattern-backtracking-palindrome-partitioning-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'backtracking', 'palindrome'],
    },
    {
        id: 'pattern-backtracking-palindrome-partitioning-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking', 'palindrome'],
    },
    {
        id: 'pattern-backtracking-palindrome-partitioning-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'backtracking', 'palindrome'],
    },
    {
        id: 'pattern-backtracking-palindrome-partitioning-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking', 'palindrome'],
    },
    {
        id: 'pattern-backtracking-parentheses-generation-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking', 'parentheses'],
    },
    {
        id: 'pattern-backtracking-parentheses-generation-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'backtracking', 'parentheses'],
    },
    {
        id: 'pattern-backtracking-parentheses-generation-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking', 'parentheses'],
    },
    {
        id: 'pattern-backtracking-parentheses-generation-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'backtracking', 'parentheses'],
    },
    {
        id: 'pattern-backtracking-parentheses-generation-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking', 'parentheses'],
    },
    {
        id: 'pattern-backtracking-permutations-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking', 'permutations'],
    },
    {
        id: 'pattern-backtracking-permutations-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking', 'permutations'],
    },
    {
        id: 'pattern-backtracking-permutations-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking', 'permutations'],
    },
    {
        id: 'pattern-backtracking-subsets-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-include-exclude-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-include-exclude-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-include-exclude-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-include-exclude-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-include-exclude-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-subsets-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking', 'subsets'],
    },
    {
        id: 'pattern-backtracking-word-search-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-path-finding-in-grid-comparison',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-path-finding-in-grid-concepts',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-path-finding-in-grid-forms',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-path-finding-in-grid-framework',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-path-finding-in-grid-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'search', 'backtracking'],
    },
    {
        id: 'pattern-backtracking-word-search-tactics',
        type: 'pattern',
        category: 'backtracking',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'search', 'backtracking'],
    },
    {
        id: 'pattern-bidirectional-bfs-bfs-optimization-for-known-source-target-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-bfs-optimization-for-known-source-target-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-bfs-optimization-for-known-source-target-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-bfs-optimization-for-known-source-target-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-bfs-optimization-for-known-source-target-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-comparison',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-concepts',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-forms',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-framework',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-bidirectional-bfs-tactics',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bfs', 'bidirectional-bfs'],
    },
    {
        id: 'pattern-binary-search-find-first-last-occurrence-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'binary', 'search', 'first', 'last', 'occurrence'],
    },
    {
        id: 'pattern-binary-search-find-first-last-occurrence-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'binary', 'search', 'first', 'last', 'occurrence'],
    },
    {
        id: 'pattern-binary-search-find-first-last-occurrence-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'binary', 'search', 'first', 'last', 'occurrence'],
    },
    {
        id: 'pattern-binary-search-find-first-last-occurrence-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'binary', 'search', 'first', 'last', 'occurrence'],
    },
    {
        id: 'pattern-binary-search-find-first-last-occurrence-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'binary', 'search', 'first', 'last', 'occurrence'],
    },
    {
        id: 'pattern-binary-search-find-min-max-in-rotated-sorted-array-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'sorted', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-binary-search-find-min-max-in-rotated-sorted-array-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'sorted', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-binary-search-find-min-max-in-rotated-sorted-array-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'sorted', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-binary-search-find-min-max-in-rotated-sorted-array-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'sorted', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-binary-search-find-min-max-in-rotated-sorted-array-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'sorted', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-binary-search-median-kth-across-two-sorted-arrays-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'sorted', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-kth-across-two-sorted-arrays-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'sorted', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-kth-across-two-sorted-arrays-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'sorted', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-kth-across-two-sorted-arrays-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'sorted', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-kth-across-two-sorted-arrays-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'sorted', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-two-arrays-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-two-arrays-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-two-arrays-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-two-arrays-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-median-two-arrays-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'binary', 'search', 'median'],
    },
    {
        id: 'pattern-binary-search-on-answer-condition-function-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-answer-condition-function-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-answer-condition-function-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-answer-condition-function-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-answer-condition-function-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-sorted-array-list-comparison',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'sorted', 'array', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-sorted-array-list-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'sorted', 'array', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-sorted-array-list-forms',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'sorted', 'array', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-sorted-array-list-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'sorted', 'array', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-on-sorted-array-list-tactics',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'sorted', 'array', 'binary', 'search'],
    },
    {
        id: 'pattern-binary-search-rotated-array-concepts',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-binary-search-rotated-array-framework',
        type: 'pattern',
        category: 'binary-search',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'binary', 'search', 'rotated'],
    },
    {
        id: 'pattern-bitwise-and-counting-set-bits-hamming-weight-comparison',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bitwise', 'hamming'],
    },
    {
        id: 'pattern-bitwise-and-counting-set-bits-hamming-weight-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bitwise', 'hamming'],
    },
    {
        id: 'pattern-bitwise-and-counting-set-bits-hamming-weight-forms',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bitwise', 'hamming'],
    },
    {
        id: 'pattern-bitwise-and-counting-set-bits-hamming-weight-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bitwise', 'hamming'],
    },
    {
        id: 'pattern-bitwise-and-counting-set-bits-hamming-weight-tactics',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bitwise', 'hamming'],
    },
    {
        id: 'pattern-bitwise-count-set-bits-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-count-set-bits-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-dp-counting-bits-optimization-comparison',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bitwise', 'counting-bits'],
    },
    {
        id: 'pattern-bitwise-dp-counting-bits-optimization-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bitwise', 'counting-bits'],
    },
    {
        id: 'pattern-bitwise-dp-counting-bits-optimization-forms',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bitwise', 'counting-bits'],
    },
    {
        id: 'pattern-bitwise-dp-counting-bits-optimization-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bitwise', 'counting-bits'],
    },
    {
        id: 'pattern-bitwise-dp-counting-bits-optimization-tactics',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bitwise', 'counting-bits'],
    },
    {
        id: 'pattern-bitwise-operations-power-of-two-four-check-comparison',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-operations-power-of-two-four-check-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-operations-power-of-two-four-check-forms',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-operations-power-of-two-four-check-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-operations-power-of-two-four-check-tactics',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bitwise'],
    },
    {
        id: 'pattern-bitwise-xor-finding-single-missing-number-comparison',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-finding-single-missing-number-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-finding-single-missing-number-forms',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-finding-single-missing-number-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-finding-single-missing-number-tactics',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-missing-comparison',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-missing-concepts',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-missing-forms',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-missing-framework',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bitwise-xor-missing-tactics',
        type: 'pattern',
        category: 'bit-manipulation',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bitwise', 'xor'],
    },
    {
        id: 'pattern-bridges-articulation-points-tarjan-low-link-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bridges', 'articulation-points'],
    },
    {
        id: 'pattern-bridges-articulation-points-tarjan-low-link-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bridges', 'articulation-points'],
    },
    {
        id: 'pattern-bridges-articulation-points-tarjan-low-link-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bridges', 'articulation-points'],
    },
    {
        id: 'pattern-bridges-articulation-points-tarjan-low-link-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bridges', 'articulation-points'],
    },
    {
        id: 'pattern-bridges-articulation-points-tarjan-low-link-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bridges', 'articulation-points'],
    },
    {
        id: 'pattern-design-general-specific-comparison',
        type: 'pattern',
        category: 'design',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'design'],
    },
    {
        id: 'pattern-design-general-specific-concepts',
        type: 'pattern',
        category: 'design',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'design'],
    },
    {
        id: 'pattern-design-general-specific-forms',
        type: 'pattern',
        category: 'design',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'design'],
    },
    {
        id: 'pattern-design-general-specific-framework',
        type: 'pattern',
        category: 'design',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'design'],
    },
    {
        id: 'pattern-design-general-specific-tactics',
        type: 'pattern',
        category: 'design',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'design'],
    },
    {
        id: 'pattern-dp-01-knapsack-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'knapsack'],
    },
    {
        id: 'pattern-dp-01-knapsack-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'knapsack'],
    },
    {
        id: 'pattern-dp-01-knapsack-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'knapsack'],
    },
    {
        id: 'pattern-dp-01-knapsack-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'knapsack'],
    },
    {
        id: 'pattern-dp-01-knapsack-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-0-1-knapsack-subset-sum-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'sum', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-0-1-knapsack-subset-sum-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'sum', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-0-1-knapsack-subset-sum-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'sum', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-0-1-knapsack-subset-sum-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'sum', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-0-1-knapsack-subset-sum-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'sum', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-coin-change-unbounded-knapsack-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-coin-change-unbounded-knapsack-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-coin-change-unbounded-knapsack-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-coin-change-unbounded-knapsack-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-coin-change-unbounded-knapsack-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'knapsack'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-style-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-style-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-style-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-style-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-style-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-fibonacci-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-kadane-s-algorithm-for-max-min-subarray-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-kadane-s-algorithm-for-max-min-subarray-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-kadane-s-algorithm-for-max-min-subarray-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-kadane-s-algorithm-for-max-min-subarray-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-kadane-s-algorithm-for-max-min-subarray-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-word-break-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-word-break-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-word-break-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-word-break-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-1d-array-word-break-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-edit-distance-levenshtein-distance-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-edit-distance-levenshtein-distance-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-edit-distance-levenshtein-distance-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-edit-distance-levenshtein-distance-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-edit-distance-levenshtein-distance-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-longest-common-subsequence-lcs-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-longest-common-subsequence-lcs-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-longest-common-subsequence-lcs-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-longest-common-subsequence-lcs-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-longest-common-subsequence-lcs-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-unique-paths-on-grid-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-unique-paths-on-grid-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-unique-paths-on-grid-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-unique-paths-on-grid-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array'],
    },
    {
        id: 'pattern-dp-2d-array-unique-paths-on-grid-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array'],
    },
    {
        id: 'pattern-dp-catalan-numbers-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-catalan-numbers-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-catalan-numbers-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-catalan-numbers-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-catalan-numbers-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-coin-change-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-coin-change-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-coin-change-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-coin-change-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-coin-change-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-edit-distance-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-edit-distance-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-edit-distance-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-edit-distance-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-edit-distance-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-fibonacci-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-fibonacci-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-fibonacci-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-fibonacci-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-fibonacci-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-interval-dp-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'interval'],
    },
    {
        id: 'pattern-dp-interval-dp-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'interval'],
    },
    {
        id: 'pattern-dp-interval-dp-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'interval'],
    },
    {
        id: 'pattern-dp-interval-dp-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'interval'],
    },
    {
        id: 'pattern-dp-interval-dp-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'interval'],
    },
    {
        id: 'pattern-dp-kadanes-algorithm-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-kadanes-algorithm-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-kadanes-algorithm-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-kadanes-algorithm-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-kadanes-algorithm-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-lcs-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-lcs-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-lcs-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-lcs-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-lcs-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-longest-increasing-subsequence-lis-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-longest-increasing-subsequence-lis-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-longest-increasing-subsequence-lis-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-longest-increasing-subsequence-lis-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-longest-increasing-subsequence-lis-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-stock-problems-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-stock-problems-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-stock-problems-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-stock-problems-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-stock-problems-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-dp-unbounded-knapsack-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'knapsack'],
    },
    {
        id: 'pattern-dp-unbounded-knapsack-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'knapsack'],
    },
    {
        id: 'pattern-dp-unique-paths-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-word-break-comparison',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-dp-word-break-concepts',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-dp-word-break-forms',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-dp-word-break-framework',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-dp-word-break-tactics',
        type: 'pattern',
        category: 'dynamic-programming',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-island-counting-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-island-counting-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-island-counting-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-island-counting-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-island-counting-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-bfs-connected-components-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-bfs-topological-sort-kahn-s-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'bfs', 'topological', 'kahn', 'graph'],
    },
    {
        id: 'pattern-graph-bfs-topological-sort-kahn-s-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'bfs', 'topological', 'kahn', 'graph'],
    },
    {
        id: 'pattern-graph-bfs-topological-sort-kahn-s-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'bfs', 'topological', 'kahn', 'graph'],
    },
    {
        id: 'pattern-graph-bfs-topological-sort-kahn-s-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'bfs', 'topological', 'kahn', 'graph'],
    },
    {
        id: 'pattern-graph-bfs-topological-sort-kahn-s-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'bfs', 'topological', 'kahn', 'graph'],
    },
    {
        id: 'pattern-graph-deep-copy-cloning-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'graph'],
    },
    {
        id: 'pattern-graph-deep-copy-cloning-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'graph'],
    },
    {
        id: 'pattern-graph-deep-copy-cloning-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'graph'],
    },
    {
        id: 'pattern-graph-deep-copy-cloning-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'graph'],
    },
    {
        id: 'pattern-graph-deep-copy-cloning-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'graph'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'dfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'dfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'dfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'dfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-island-counting-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'dfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-island-counting-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'dfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-island-counting-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'dfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-island-counting-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'dfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-island-counting-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'dfs', 'graph', 'connected-components', 'island'],
    },
    {
        id: 'pattern-graph-dfs-connected-components-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'dfs', 'graph', 'connected-components'],
    },
    {
        id: 'pattern-graph-dfs-cycle-detection-directed-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'dfs', 'cycle', 'graph'],
    },
    {
        id: 'pattern-graph-dfs-cycle-detection-directed-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'dfs', 'cycle', 'graph'],
    },
    {
        id: 'pattern-graph-dfs-cycle-detection-directed-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'dfs', 'cycle', 'graph'],
    },
    {
        id: 'pattern-graph-dfs-cycle-detection-directed-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'dfs', 'cycle', 'graph'],
    },
    {
        id: 'pattern-graph-dfs-cycle-detection-directed-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'dfs', 'cycle', 'graph'],
    },
    {
        id: 'pattern-graph-shortest-path-bellman-ford-bfs-k-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'bfs', 'bellman-ford', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-bellman-ford-bfs-k-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'bfs', 'bellman-ford', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-bellman-ford-bfs-k-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'bfs', 'bellman-ford', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-bellman-ford-bfs-k-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'bfs', 'bellman-ford', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-bellman-ford-bfs-k-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'bfs', 'bellman-ford', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-dijkstra-s-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'dijkstra', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-dijkstra-s-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'dijkstra', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-dijkstra-s-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'dijkstra', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-dijkstra-s-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'dijkstra', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-shortest-path-dijkstra-s-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'dijkstra', 'graph', 'shortest-path'],
    },
    {
        id: 'pattern-graph-union-find-disjoint-set-union-dsu-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'union-find', 'dsu', 'graph'],
    },
    {
        id: 'pattern-graph-union-find-disjoint-set-union-dsu-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'union-find', 'dsu', 'graph'],
    },
    {
        id: 'pattern-graph-union-find-disjoint-set-union-dsu-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'union-find', 'dsu', 'graph'],
    },
    {
        id: 'pattern-graph-union-find-disjoint-set-union-dsu-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'union-find', 'dsu', 'graph'],
    },
    {
        id: 'pattern-graph-union-find-disjoint-set-union-dsu-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'union-find', 'dsu', 'graph'],
    },
    {
        id: 'pattern-greedy-buy-sell-stock-comparison',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'greedy'],
    },
    {
        id: 'pattern-greedy-buy-sell-stock-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'greedy'],
    },
    {
        id: 'pattern-greedy-buy-sell-stock-forms',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'greedy'],
    },
    {
        id: 'pattern-greedy-buy-sell-stock-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'greedy'],
    },
    {
        id: 'pattern-greedy-buy-sell-stock-tactics',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'greedy'],
    },
    {
        id: 'pattern-greedy-gas-station-circuit-comparison',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'greedy'],
    },
    {
        id: 'pattern-greedy-gas-station-circuit-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'greedy'],
    },
    {
        id: 'pattern-greedy-gas-station-circuit-forms',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'greedy'],
    },
    {
        id: 'pattern-greedy-gas-station-circuit-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'greedy'],
    },
    {
        id: 'pattern-greedy-gas-station-circuit-tactics',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'greedy'],
    },
    {
        id: 'pattern-greedy-interval-merging-scheduling-comparison',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'greedy', 'interval', 'scheduling'],
    },
    {
        id: 'pattern-greedy-interval-merging-scheduling-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'greedy', 'interval', 'scheduling'],
    },
    {
        id: 'pattern-greedy-interval-merging-scheduling-forms',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'greedy', 'interval', 'scheduling'],
    },
    {
        id: 'pattern-greedy-interval-merging-scheduling-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'greedy', 'interval', 'scheduling'],
    },
    {
        id: 'pattern-greedy-interval-merging-scheduling-tactics',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'greedy', 'interval', 'scheduling'],
    },
    {
        id: 'pattern-greedy-jump-game-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-jump-game-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-jump-game-reachability-minimization-comparison',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-jump-game-reachability-minimization-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-jump-game-reachability-minimization-forms',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-jump-game-reachability-minimization-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-jump-game-reachability-minimization-tactics',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'greedy', 'jump-game'],
    },
    {
        id: 'pattern-greedy-sorting-based-comparison',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'greedy'],
    },
    {
        id: 'pattern-greedy-sorting-based-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'greedy'],
    },
    {
        id: 'pattern-greedy-sorting-based-forms',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'greedy'],
    },
    {
        id: 'pattern-greedy-sorting-based-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'greedy'],
    },
    {
        id: 'pattern-greedy-sorting-based-tactics',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'greedy'],
    },
    {
        id: 'pattern-greedy-task-scheduling-frequency-based-comparison',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-greedy-task-scheduling-frequency-based-concepts',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-greedy-task-scheduling-frequency-based-forms',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-greedy-task-scheduling-frequency-based-framework',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-greedy-task-scheduling-frequency-based-tactics',
        type: 'pattern',
        category: 'greedy',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-heap-k-way-merge-comparison',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'merge', 'heap'],
    },
    {
        id: 'pattern-heap-k-way-merge-concepts',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'merge', 'heap'],
    },
    {
        id: 'pattern-heap-k-way-merge-forms',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'merge', 'heap'],
    },
    {
        id: 'pattern-heap-k-way-merge-framework',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'merge', 'heap'],
    },
    {
        id: 'pattern-heap-k-way-merge-tactics',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'merge', 'heap'],
    },
    {
        id: 'pattern-heap-scheduling-minimum-cost-greedy-with-priority-queue-comparison',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'queue', 'heap', 'priority', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-heap-scheduling-minimum-cost-greedy-with-priority-queue-concepts',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'queue', 'heap', 'priority', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-heap-scheduling-minimum-cost-greedy-with-priority-queue-forms',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'queue', 'heap', 'priority', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-heap-scheduling-minimum-cost-greedy-with-priority-queue-framework',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'queue', 'heap', 'priority', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-heap-scheduling-minimum-cost-greedy-with-priority-queue-tactics',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'queue', 'heap', 'priority', 'greedy', 'scheduling'],
    },
    {
        id: 'pattern-heap-top-k-elements-selection-frequency-comparison',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'heap'],
    },
    {
        id: 'pattern-heap-top-k-elements-selection-frequency-concepts',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'heap'],
    },
    {
        id: 'pattern-heap-top-k-elements-selection-frequency-forms',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'heap'],
    },
    {
        id: 'pattern-heap-top-k-elements-selection-frequency-framework',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'heap'],
    },
    {
        id: 'pattern-heap-top-k-elements-selection-frequency-tactics',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'heap'],
    },
    {
        id: 'pattern-heap-two-heaps-for-median-finding-comparison',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'median', 'heap'],
    },
    {
        id: 'pattern-heap-two-heaps-for-median-finding-concepts',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'median', 'heap'],
    },
    {
        id: 'pattern-heap-two-heaps-for-median-finding-forms',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'median', 'heap'],
    },
    {
        id: 'pattern-heap-two-heaps-for-median-finding-framework',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'median', 'heap'],
    },
    {
        id: 'pattern-heap-two-heaps-for-median-finding-tactics',
        type: 'pattern',
        category: 'heap',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'median', 'heap'],
    },
    {
        id: 'pattern-linked-list-addition-of-numbers-comparison',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'linked-list', 'addition'],
    },
    {
        id: 'pattern-linked-list-addition-of-numbers-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'linked-list', 'addition'],
    },
    {
        id: 'pattern-linked-list-addition-of-numbers-forms',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'linked-list', 'addition'],
    },
    {
        id: 'pattern-linked-list-addition-of-numbers-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'linked-list', 'addition'],
    },
    {
        id: 'pattern-linked-list-addition-of-numbers-tactics',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'linked-list', 'addition'],
    },
    {
        id: 'pattern-linked-list-in-place-reversal-comparison',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'in-place', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-in-place-reversal-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'in-place', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-in-place-reversal-forms',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'in-place', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-in-place-reversal-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'in-place', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-in-place-reversal-tactics',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'in-place', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-intersection-detection-comparison',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-intersection-detection-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-intersection-detection-forms',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-intersection-detection-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-intersection-detection-tactics',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merge-sorted-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'merge', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merge-sorted-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'merge', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merging-two-sorted-lists-comparison',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merging-two-sorted-lists-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merging-two-sorted-lists-forms',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merging-two-sorted-lists-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-merging-two-sorted-lists-tactics',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'sorted', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-reordering-partitioning-comparison',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-reordering-partitioning-concepts',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-reordering-partitioning-forms',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-reordering-partitioning-framework',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-reordering-partitioning-tactics',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'linked-list'],
    },
    {
        id: 'pattern-linked-list-reversal-comparison',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-reversal-forms',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-linked-list-reversal-tactics',
        type: 'pattern',
        category: 'linked-list',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'linked-list', 'reversal'],
    },
    {
        id: 'pattern-minimum-spanning-tree-kruskal-prim-dsu-heap-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'dsu', 'kruskal', 'prim', 'minimum-spanning-tree', 'heap'],
    },
    {
        id: 'pattern-minimum-spanning-tree-kruskal-prim-dsu-heap-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'dsu', 'kruskal', 'prim', 'minimum-spanning-tree', 'heap'],
    },
    {
        id: 'pattern-minimum-spanning-tree-kruskal-prim-dsu-heap-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'dsu', 'kruskal', 'prim', 'minimum-spanning-tree', 'heap'],
    },
    {
        id: 'pattern-minimum-spanning-tree-kruskal-prim-dsu-heap-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'dsu', 'kruskal', 'prim', 'minimum-spanning-tree', 'heap'],
    },
    {
        id: 'pattern-minimum-spanning-tree-kruskal-prim-dsu-heap-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'dsu', 'kruskal', 'prim', 'minimum-spanning-tree', 'heap'],
    },
    {
        id: 'pattern-sliding-window-character-frequency-matching-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-character-frequency-matching-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-character-frequency-matching-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-character-frequency-matching-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-character-frequency-matching-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-fixed-size-subarray-calculation-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'sliding-window', 'fixed'],
    },
    {
        id: 'pattern-sliding-window-fixed-size-subarray-calculation-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'sliding-window', 'fixed'],
    },
    {
        id: 'pattern-sliding-window-fixed-size-subarray-calculation-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'sliding-window', 'fixed'],
    },
    {
        id: 'pattern-sliding-window-fixed-size-subarray-calculation-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'sliding-window', 'fixed'],
    },
    {
        id: 'pattern-sliding-window-fixed-size-subarray-calculation-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'sliding-window', 'fixed'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-for-max-min-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sliding-window', 'monotonic', 'queue'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-for-max-min-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sliding-window', 'monotonic', 'queue'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-for-max-min-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sliding-window', 'monotonic', 'queue'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-for-max-min-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sliding-window', 'monotonic', 'queue'],
    },
    {
        id: 'pattern-sliding-window-monotonic-queue-for-max-min-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sliding-window', 'monotonic', 'queue'],
    },
    {
        id: 'pattern-sliding-window-variable-size-condition-based-comparison',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-variable-size-condition-based-concepts',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-variable-size-condition-based-forms',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-variable-size-condition-based-framework',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sliding-window'],
    },
    {
        id: 'pattern-sliding-window-variable-size-condition-based-tactics',
        type: 'pattern',
        category: 'sliding-window',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sliding-window'],
    },
    {
        id: 'pattern-stack-expression-evaluation-rpn-infix-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'stack'],
    },
    {
        id: 'pattern-stack-expression-evaluation-rpn-infix-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'stack'],
    },
    {
        id: 'pattern-stack-expression-evaluation-rpn-infix-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'stack'],
    },
    {
        id: 'pattern-stack-expression-evaluation-rpn-infix-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'stack'],
    },
    {
        id: 'pattern-stack-expression-evaluation-rpn-infix-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'stack'],
    },
    {
        id: 'pattern-stack-largest-rectangle-in-histogram-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'stack', 'histogram', 'rectangle'],
    },
    {
        id: 'pattern-stack-largest-rectangle-in-histogram-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'stack', 'histogram', 'rectangle'],
    },
    {
        id: 'pattern-stack-largest-rectangle-in-histogram-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'stack', 'histogram', 'rectangle'],
    },
    {
        id: 'pattern-stack-largest-rectangle-in-histogram-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'stack', 'histogram', 'rectangle'],
    },
    {
        id: 'pattern-stack-largest-rectangle-in-histogram-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'stack', 'histogram', 'rectangle'],
    },
    {
        id: 'pattern-stack-min-stack-design-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'stack', 'design', 'min-stack'],
    },
    {
        id: 'pattern-stack-min-stack-design-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'stack', 'design', 'min-stack'],
    },
    {
        id: 'pattern-stack-min-stack-design-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'stack', 'design', 'min-stack'],
    },
    {
        id: 'pattern-stack-min-stack-design-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'stack', 'design', 'min-stack'],
    },
    {
        id: 'pattern-stack-min-stack-design-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'stack', 'design', 'min-stack'],
    },
    {
        id: 'pattern-stack-monotonic-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-monotonic-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-monotonic-stack-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-monotonic-stack-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-monotonic-stack-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-monotonic-stack-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-monotonic-stack-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'monotonic', 'stack'],
    },
    {
        id: 'pattern-stack-simulation-backtracking-helper-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'backtracking', 'stack'],
    },
    {
        id: 'pattern-stack-simulation-backtracking-helper-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'backtracking', 'stack'],
    },
    {
        id: 'pattern-stack-simulation-backtracking-helper-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'backtracking', 'stack'],
    },
    {
        id: 'pattern-stack-simulation-backtracking-helper-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'backtracking', 'stack'],
    },
    {
        id: 'pattern-stack-simulation-backtracking-helper-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'backtracking', 'stack'],
    },
    {
        id: 'pattern-stack-valid-parentheses-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-matching-comparison',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-matching-concepts',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-matching-forms',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-matching-framework',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-matching-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-stack-valid-parentheses-tactics',
        type: 'pattern',
        category: 'stack',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'stack', 'parentheses'],
    },
    {
        id: 'pattern-string-anagram-check-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-frequency-count-sort-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-frequency-count-sort-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-frequency-count-sort-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-frequency-count-sort-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-frequency-count-sort-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'string'],
    },
    {
        id: 'pattern-string-anagram-check-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'string'],
    },
    {
        id: 'pattern-string-matching-naive-kmp-rabin-karp-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'string'],
    },
    {
        id: 'pattern-string-matching-naive-kmp-rabin-karp-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'string'],
    },
    {
        id: 'pattern-string-matching-naive-kmp-rabin-karp-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'string'],
    },
    {
        id: 'pattern-string-matching-naive-kmp-rabin-karp-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'string'],
    },
    {
        id: 'pattern-string-matching-naive-kmp-rabin-karp-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'string'],
    },
    {
        id: 'pattern-string-multiply-strings-manual-simulation-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'string', 'multiply'],
    },
    {
        id: 'pattern-string-multiply-strings-manual-simulation-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'string', 'multiply'],
    },
    {
        id: 'pattern-string-multiply-strings-manual-simulation-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'string', 'multiply'],
    },
    {
        id: 'pattern-string-multiply-strings-manual-simulation-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'string', 'multiply'],
    },
    {
        id: 'pattern-string-multiply-strings-manual-simulation-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'string', 'multiply'],
    },
    {
        id: 'pattern-string-palindrome-check-two-pointers-reverse-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'two-pointers', 'string', 'palindrome', 'reverse'],
    },
    {
        id: 'pattern-string-palindrome-check-two-pointers-reverse-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'two-pointers', 'string', 'palindrome', 'reverse'],
    },
    {
        id: 'pattern-string-palindrome-check-two-pointers-reverse-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'two-pointers', 'string', 'palindrome', 'reverse'],
    },
    {
        id: 'pattern-string-palindrome-check-two-pointers-reverse-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'two-pointers', 'string', 'palindrome', 'reverse'],
    },
    {
        id: 'pattern-string-palindrome-check-two-pointers-reverse-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'two-pointers', 'string', 'palindrome', 'reverse'],
    },
    {
        id: 'pattern-string-repeated-substring-pattern-detection-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'string'],
    },
    {
        id: 'pattern-string-repeated-substring-pattern-detection-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'string'],
    },
    {
        id: 'pattern-string-repeated-substring-pattern-detection-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'string'],
    },
    {
        id: 'pattern-string-repeated-substring-pattern-detection-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'string'],
    },
    {
        id: 'pattern-string-repeated-substring-pattern-detection-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'string'],
    },
    {
        id: 'pattern-string-roman-to-integer-conversion-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'string'],
    },
    {
        id: 'pattern-string-roman-to-integer-conversion-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'string'],
    },
    {
        id: 'pattern-string-roman-to-integer-conversion-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'string'],
    },
    {
        id: 'pattern-string-roman-to-integer-conversion-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'string'],
    },
    {
        id: 'pattern-string-roman-to-integer-conversion-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'string'],
    },
    {
        id: 'pattern-string-string-to-integer-atoi-comparison',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'string', 'atoi'],
    },
    {
        id: 'pattern-string-string-to-integer-atoi-concepts',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'string', 'atoi'],
    },
    {
        id: 'pattern-string-string-to-integer-atoi-forms',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'string', 'atoi'],
    },
    {
        id: 'pattern-string-string-to-integer-atoi-framework',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'string', 'atoi'],
    },
    {
        id: 'pattern-string-string-to-integer-atoi-tactics',
        type: 'pattern',
        category: 'strings',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'string', 'atoi'],
    },
    {
        id: 'pattern-strongly-connected-components-comparison',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-concepts',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-forms',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-framework',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-kosaraju-tarjan-comparison',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-kosaraju-tarjan-concepts',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-kosaraju-tarjan-forms',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-kosaraju-tarjan-framework',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-kosaraju-tarjan-tactics',
        type: 'pattern',
        category: 'graphs',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-strongly-connected-components-tactics',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'connected-components', 'strongly-connected-components'],
    },
    {
        id: 'pattern-tree-bfs-level-order-traversal-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'traversal', 'bfs', 'level-order'],
    },
    {
        id: 'pattern-tree-bfs-level-order-traversal-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'traversal', 'bfs', 'level-order'],
    },
    {
        id: 'pattern-tree-bfs-level-order-traversal-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'traversal', 'bfs', 'level-order'],
    },
    {
        id: 'pattern-tree-bfs-level-order-traversal-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'traversal', 'bfs', 'level-order'],
    },
    {
        id: 'pattern-tree-bfs-level-order-traversal-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'traversal', 'bfs', 'level-order'],
    },
    {
        id: 'pattern-tree-dfs-recursive-inorder-traversal-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'traversal', 'dfs', 'inorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-inorder-traversal-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'traversal', 'dfs', 'inorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-inorder-traversal-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'traversal', 'dfs', 'inorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-inorder-traversal-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'traversal', 'dfs', 'inorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-inorder-traversal-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'traversal', 'dfs', 'inorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-postorder-traversal-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'traversal', 'dfs', 'postorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-postorder-traversal-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'traversal', 'dfs', 'postorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-postorder-traversal-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'traversal', 'dfs', 'postorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-postorder-traversal-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'traversal', 'dfs', 'postorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-postorder-traversal-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'traversal', 'dfs', 'postorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-preorder-traversal-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'traversal', 'dfs', 'preorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-preorder-traversal-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'traversal', 'dfs', 'preorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-preorder-traversal-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'traversal', 'dfs', 'preorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-preorder-traversal-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'traversal', 'dfs', 'preorder'],
    },
    {
        id: 'pattern-tree-dfs-recursive-preorder-traversal-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'traversal', 'dfs', 'preorder'],
    },
    {
        id: 'pattern-tree-lowest-common-ancestor-lca-finding-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-tree-lowest-common-ancestor-lca-finding-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-tree-lowest-common-ancestor-lca-finding-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-tree-lowest-common-ancestor-lca-finding-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-tree-lowest-common-ancestor-lca-finding-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-tree-serialization-deserialization-comparison',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison'],
    },
    {
        id: 'pattern-tree-serialization-deserialization-concepts',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts'],
    },
    {
        id: 'pattern-tree-serialization-deserialization-forms',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms'],
    },
    {
        id: 'pattern-tree-serialization-deserialization-framework',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework'],
    },
    {
        id: 'pattern-tree-serialization-deserialization-tactics',
        type: 'pattern',
        category: 'trees',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics'],
    },
    {
        id: 'pattern-trie-prefix-tree-comparison',
        type: 'pattern',
        category: 'trie',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'prefix', 'trie', 'prefix-tree'],
    },
    {
        id: 'pattern-trie-prefix-tree-forms',
        type: 'pattern',
        category: 'trie',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'prefix', 'trie', 'prefix-tree'],
    },
    {
        id: 'pattern-trie-prefix-tree-framework',
        type: 'pattern',
        category: 'trie',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'prefix', 'trie', 'prefix-tree'],
    },
    {
        id: 'pattern-trie-prefix-tree-tactics',
        type: 'pattern',
        category: 'trie',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'prefix', 'trie', 'prefix-tree'],
    },
    {
        id: 'pattern-tries-comparison',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'trie'],
    },
    {
        id: 'pattern-tries-concepts',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'trie'],
    },
    {
        id: 'pattern-tries-forms',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'trie'],
    },
    {
        id: 'pattern-tries-framework',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'trie'],
    },
    {
        id: 'pattern-tries-tactics',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'trie'],
    },
    {
        id: 'pattern-two-pointers-converging-sorted-array-target-sum-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'sort', 'sorted', 'array', 'sum', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-converging-sorted-array-target-sum-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'sort', 'sorted', 'array', 'sum', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-converging-sorted-array-target-sum-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'sort', 'sorted', 'array', 'sum', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-converging-sorted-array-target-sum-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'sort', 'sorted', 'array', 'sum', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-converging-sorted-array-target-sum-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'sort', 'sorted', 'array', 'sum', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-expanding-from-center-palindromes-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'two-pointers', 'expanding', 'palindrome'],
    },
    {
        id: 'pattern-two-pointers-expanding-from-center-palindromes-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'two-pointers', 'expanding', 'palindrome'],
    },
    {
        id: 'pattern-two-pointers-expanding-from-center-palindromes-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'two-pointers', 'expanding', 'palindrome'],
    },
    {
        id: 'pattern-two-pointers-expanding-from-center-palindromes-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'two-pointers', 'expanding', 'palindrome'],
    },
    {
        id: 'pattern-two-pointers-expanding-from-center-palindromes-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'two-pointers', 'expanding', 'palindrome'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-cycle-detection-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'two-pointers', 'fast-slow', 'cycle'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-cycle-detection-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'two-pointers', 'fast-slow', 'cycle'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-cycle-detection-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'two-pointers', 'fast-slow', 'cycle'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-cycle-detection-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'two-pointers', 'fast-slow', 'cycle'],
    },
    {
        id: 'pattern-two-pointers-fast-slow-cycle-detection-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'two-pointers', 'fast-slow', 'cycle'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-nth-node-from-end-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'two-pointers', 'fixed', 'separation'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-nth-node-from-end-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'two-pointers', 'fixed', 'separation'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-nth-node-from-end-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'two-pointers', 'fixed', 'separation'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-nth-node-from-end-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'two-pointers', 'fixed', 'separation'],
    },
    {
        id: 'pattern-two-pointers-fixed-separation-nth-node-from-end-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'two-pointers', 'fixed', 'separation'],
    },
    {
        id: 'pattern-two-pointers-in-place-array-modification-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'array', 'in-place', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-in-place-array-modification-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'array', 'in-place', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-in-place-array-modification-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'array', 'in-place', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-in-place-array-modification-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'array', 'in-place', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-in-place-array-modification-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'array', 'in-place', 'two-pointers'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-with-backspaces-comparison',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'two-pointers', 'string'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-with-backspaces-concepts',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'two-pointers', 'string'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-with-backspaces-forms',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'two-pointers', 'string'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-with-backspaces-framework',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'two-pointers', 'string'],
    },
    {
        id: 'pattern-two-pointers-string-comparison-with-backspaces-tactics',
        type: 'pattern',
        category: 'two-pointers',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'two-pointers', 'string'],
    },
    {
        id: 'pattern-union-find-comparison',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['comparison', 'union-find'],
    },
    {
        id: 'pattern-union-find-concepts',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'easy',
        tags: ['concepts', 'union-find'],
    },
    {
        id: 'pattern-union-find-forms',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['forms', 'union-find'],
    },
    {
        id: 'pattern-union-find-framework',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'medium',
        tags: ['framework', 'union-find'],
    },
    {
        id: 'pattern-union-find-tactics',
        type: 'pattern',
        category: 'general',
        front: '',
        back: '',
        difficulty: 'hard',
        tags: ['tactics', 'union-find'],
    },
];

// Helper to get cards by category
export const getFlashCardsByCategory = (categoryId: string | null): FlashCard[] => {
    if (!categoryId || categoryId === 'all') {
        return FLASH_CARDS_DATA;
    }
    return FLASH_CARDS_DATA.filter((card) => card.category === categoryId);
};

// Helper to get cards due for review
export const getDueFlashCards = (
    cards: FlashCard[],
    progressMap: Map<string, { nextReviewDate: string | null }>,
    today: string
): FlashCard[] => {
    return cards.filter((card) => {
        const progress = progressMap.get(card.id);
        if (!progress || !progress.nextReviewDate) return true; // New cards
        return progress.nextReviewDate <= today;
    });
};

// Get unique categories with type information
export const getFlashCardCategories = (): { id: string; name: string; type: string }[] => {
    const categories = new Map<string, { name: string; type: string }>();

    // Add 'all' category first
    categories.set('all', { name: 'All Cards', type: 'all' });

    FLASH_CARDS_DATA.forEach((card) => {
        if (!categories.has(card.category)) {
            // Convert category ID to readable name
            const name = card.category
                .split('-')
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(' ');
            categories.set(card.category, { name, type: card.type });
        }
    });

    return Array.from(categories.entries())
        .map(([id, { name, type }]) => ({ id, name, type }))
        .sort((a, b) => {
            // 'all' should always be first
            if (a.id === 'all') return -1;
            if (b.id === 'all') return 1;
            // Sort by type first, then by name
            if (a.type !== b.type) {
                const typeOrder = { algorithm: 0, pattern: 1, sql: 2 };
                return (
                    (typeOrder[a.type as keyof typeof typeOrder] || 3) -
                    (typeOrder[b.type as keyof typeof typeOrder] || 3)
                );
            }
            return a.name.localeCompare(b.name);
        });
};
